interface Props {
  style?: React.CSSProperties
  className?: string
  color?: string
}

export function ArrowDownSec({ style, className = '', color = 'white' }: Props) {
  return (
    <i className={`icon ${className}`} style={style}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_360_33432)">
          <path d="M10.9997 5V16.17L6.11973 11.29C5.72973 10.9 5.08973 10.9 4.69973 11.29C4.30973 11.68 4.30973 12.31 4.69973 12.7L11.2897 19.29C11.6797 19.68 12.3097 19.68 12.6997 19.29L19.2897 12.7C19.6797 12.31 19.6797 11.68 19.2897 11.29C18.8997 10.9 18.2697 10.9 17.8797 11.29L12.9997 16.17V5C12.9997 4.45 12.5497 4 11.9997 4C11.4497 4 10.9997 4.45 10.9997 5Z" fill={color}/>
        </g>
        <defs>
          <clipPath id="clip0_360_33432">
            <rect width="24" height="24" fill={color}/>
          </clipPath>
        </defs>
      </svg>
    </i>
  )
}
